import { useBackToClose } from "../../hooks/useBackToClose";

export function Modal({ title, onClose, children, size = "default" }) {
  // Back closes this dialog rather than navigating the page away behind it.
  useBackToClose(onClose);
  const sizeClass = size === "wide" ? "max-w-[95vw]"
    : size === "full" ? "max-w-full"
    : "max-w-lg";
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className={`bg-white rounded-2xl shadow-2xl w-full ${sizeClass} max-h-[90vh] overflow-y-auto`} onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="font-bold text-gray-800">{title}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl leading-none" data-testid="modal-close-btn">&times;</button>
        </div>
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
}
